module.exports = __webpack_public_path__ + "img/bmw-select.a5cc0643.jpg";